import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Alert,
  Box // For flexible spacing
} from '@mui/material';

const Warning = ({ isOpen, onClose, onProceed, msgPrimary, msgSecondary, disableProceed }) => {
  return (
    <Box sx={{ p: 4 }}>
        <Dialog
        open={isOpen}
        onClose={onClose} // Allows closing by clicking outside or pressing Esc
        aria-labelledby="submission-warning-dialog-title"
        aria-describedby="submission-warning-dialog-description"
        >
        <DialogTitle id="submission-warning-dialog-title">
            <Alert severity="warning" variant="filled">
                Warning: Existing Request Detected
            </Alert>
        </DialogTitle>
        <DialogContent>
            <Typography variant="body1" id="submission-warning-dialog-description" sx={{ mt: 2 }}>
                {/* It looks like you have already submitted a request to the surgeons.
                Proceeding will update your existing request and resend your data to the surgeon. */}
                {msgPrimary}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {/* Are you sure you want to continue to the form? */}
                {msgSecondary}
            </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
            <Button onClick={onClose} variant="outlined" color="primary">
                Close
            </Button>
            <Button onClick={onProceed} disabled={disableProceed} variant="contained" color="primary">
                Proceed To Form
            </Button>
        </DialogActions>
        </Dialog>
    </Box>
  );
}

export default Warning;